import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { SitesRouteNames, SitesRoutePathNames } from '../../enums';
import { beforeEnter } from './../guards';

const Component = () => import('./AppConfig.vue');

export default {
  path: buildChildURL(
    SitesRoutePathNames.SITE,
    SitesRoutePathNames.STATION_DETAILS,
    SitesRoutePathNames.STATION,
    // Only Thrive and Boost, as their lowercase integration keys, open this page
    `${SitesRoutePathNames.INTEGRATION_TYPE}(thrive|boost)`,
  ),
  sensitive: true,
  name: SitesRouteNames.SITE_STATION_APP_CONFIG,
  component: Component,
  props: (route) => ({ integrationKey: route.params.integrationType }),
  beforeEnter: beforeEnter,
} as RouteRecordRaw;
